<template>
  <div>
    <div v-for="answer in post.answers" :key="answer.id">
      <div
          v-if="
                    isValueEmpty(answer.value) &&
                    showPersonnalData(answer) &&
                    answer.label !== 'Objet' &&
                    !isMedias(answer.form_attribute_type_id)
                "
          class="bg-white border-t border-gray-200 px-4 sm:px-6 divide-y divide-gray-200 shadow sm:rounded-lg px-4 sm:px-6 mb-1"
      >
        <article class="py-4 px-4">
          <component
              :medias="post.medias"
              :is="answer.name"
              :value="answer"
              :post="post"
          />
        </article>
      </div>
      <div
          v-if="
                    isMedias(answer.form_attribute_type_id) &&
                    isValueEmpty(answer.value)
                "
          class="bg-white border-t border-gray-200 px-4 sm:px-6 divide-y divide-gray-200 shadow sm:rounded-lg px-4 sm:px-6 mb-1"
      >
        <article class="py-4 px-4">
          <file-upload
              :value="answer"
              :medias="post.medias"
              :isConnected="isConnected"
              :isIdentified="isIdentified"
          ></file-upload>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import MapPostCard from '@/components/Model/Map/MapPostCard'
import ClassicAttribute from './Attribute/ClassicAttribute'
import CategoryAttribute from './Attribute/CategoryAttribute'
import DateAttribute from './Attribute/DateAttribute'
import DateTimeAttribute from './Attribute/DateTimeAttribute'
import FileAttribute from './Attribute/FileAttribute'
import CheckboxAttribute from './Attribute/CheckboxAttribute'
import RadioAttribute from './Attribute/RadioAttribute'

export default {
  name: 'PostAnswers',
  components: {
    location: MapPostCard,
    category: CategoryAttribute,
    gdpr: CheckboxAttribute,
    smalltext: ClassicAttribute,
    email: ClassicAttribute,
    markdown: ClassicAttribute,
    rating: ClassicAttribute,
    'file-upload': FileAttribute,
    'select-field': ClassicAttribute,
    checkbox: CheckboxAttribute,
    radio: RadioAttribute,
    date: DateAttribute,
    datetime: DateTimeAttribute,
    number: ClassicAttribute
  },

  props: ['post', 'isConnected', 'isIdentified'],
  methods: {
    isMedias(value) {
      if (value === 12) {
        return true
      } else {
        return false
      }
    },
    isValueEmpty(value) {
      if (value) {
        if (typeof value === 'string') {
          return value !== ''
        } else if (typeof value === 'object') {
          return value.length > 0 || Object.keys(value).length > 0
        } else {
          return value
        }
      } else {
        return false
      }
    },
    showPersonnalData(answer) {
      if (answer.response_private === 1) {
        if (this.isConnected === true) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped></style>
